<div class="body-container">
  <div class="comments-container" *ngIf="!isUpdatingDeleted">
    <ng-container *ngFor="let comment of codeReviewComments; let i = index">
      <ng-container *ngIf="comment.comment_type == 'NORMAL_COMMENT'">
        <ng-container *ngTemplateOutlet="normalCommentTemplate; context: { comment: comment, pos: i }"></ng-container>
      </ng-container>
      <ng-container *ngIf="comment.comment_type == 'REVIEW_COMMENT' && comment.parent_comment_id == null">
        <ng-container *ngTemplateOutlet="reviewCommentTemplate; context: { comment: comment, pos: i }"></ng-container>
      </ng-container>
    </ng-container>

    <div class="newtextarea">
      <form [formGroup]="normalCommentForm" (ngSubmit)="addNormalComment()" *ngIf="conversationApiLoaded">

        <mat-form-field appearance="fill">
          <!-- <mat-label>Add Comment</mat-label> -->
          <textarea matInput placeholder="Add your comment here" formControlName="comment"></textarea>
        </mat-form-field>
        <div class="btnnew">
          <button class="btn btn-primary newbtn" type="submit" [featureActionState]="'CODE_REVIEW'"
            [disabled]="normalCommentForm.controls.comment.value == ''">Submit</button>

          <button *ngIf="codeReviewState == 'CLOSED' && isCurrentUserCodeReview()" (click)="openCodeReview()" [disabled]="isOtherCodeReviewOpenedForArtifactId" [featureActionState]="'CODE_REVIEW'">Reopen Code Review</button>
          <button *ngIf="codeReviewState == 'OPENED' && isCurrentUserCodeReview()" (click)="closeCodeReview()" [featureActionState]="'CODE_REVIEW'">
            <svg aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-git-pull-request-closed closed">
              <path d="M3.25 1A2.25 2.25 0 0 1 4 5.372v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.251 2.251 0 0 1 3.25 1Zm9.5 5.5a.75.75 0 0 1 .75.75v3.378a2.251 2.251 0 1 1-1.5 0V7.25a.75.75 0 0 1 .75-.75Zm-2.03-5.273a.75.75 0 0 1 1.06 0l.97.97.97-.97a.748.748 0 0 1 1.265.332.75.75 0 0 1-.205.729l-.97.97.97.97a.751.751 0 0 1-.018 1.042.751.751 0 0 1-1.042.018l-.97-.97-.97.97a.749.749 0 0 1-1.275-.326.749.749 0 0 1 .215-.734l.97-.97-.97-.97a.75.75 0 0 1 0-1.06ZM2.5 3.25a.75.75 0 1 0 1.5 0 .75.75 0 0 0-1.5 0ZM3.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm9.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"></path>
            </svg>
            Close Code Review
          </button>
        </div>

      </form>
    </div>


  </div>
  <div class="reviewers-container">
    <div class="reviewers-section">
      <div class="reviewers-header">
        Reviewers
        <!-- <mat-icon (click)="openEditReviwers()" *ngIf="!editReviewers && !isReviewerLoading && isCurrentUserCodeReview()">settings</mat-icon> -->
        <svg (click)="openEditReviwers()" *ngIf="!editReviewers && !isReviewerLoading && isCurrentUserCodeReview() && this.codeReviewState == 'OPENED'" aria-hidden="true" height="16" viewBox="0 0 16 16"
          version="1.1" width="16" data-view-component="true" class="octicon octicon-gear" [featureActionState]="'CODE_REVIEW'">
          <path
            d="M8 0a8.2 8.2 0 0 1 .701.031C9.444.095 9.99.645 10.16 1.29l.288 1.107c.018.066.079.158.212.224.231.114.454.243.668.386.123.082.233.09.299.071l1.103-.303c.644-.176 1.392.021 1.82.63.27.385.506.792.704 1.218.315.675.111 1.422-.364 1.891l-.814.806c-.049.048-.098.147-.088.294.016.257.016.515 0 .772-.01.147.038.246.088.294l.814.806c.475.469.679 1.216.364 1.891a7.977 7.977 0 0 1-.704 1.217c-.428.61-1.176.807-1.82.63l-1.102-.302c-.067-.019-.177-.011-.3.071a5.909 5.909 0 0 1-.668.386c-.133.066-.194.158-.211.224l-.29 1.106c-.168.646-.715 1.196-1.458 1.26a8.006 8.006 0 0 1-1.402 0c-.743-.064-1.289-.614-1.458-1.26l-.289-1.106c-.018-.066-.079-.158-.212-.224a5.738 5.738 0 0 1-.668-.386c-.123-.082-.233-.09-.299-.071l-1.103.303c-.644.176-1.392-.021-1.82-.63a8.12 8.12 0 0 1-.704-1.218c-.315-.675-.111-1.422.363-1.891l.815-.806c.05-.048.098-.147.088-.294a6.214 6.214 0 0 1 0-.772c.01-.147-.038-.246-.088-.294l-.815-.806C.635 6.045.431 5.298.746 4.623a7.92 7.92 0 0 1 .704-1.217c.428-.61 1.176-.807 1.82-.63l1.102.302c.067.019.177.011.3-.071.214-.143.437-.272.668-.386.133-.066.194-.158.211-.224l.29-1.106C6.009.645 6.556.095 7.299.03 7.53.01 7.764 0 8 0Zm-.571 1.525c-.036.003-.108.036-.137.146l-.289 1.105c-.147.561-.549.967-.998 1.189-.173.086-.34.183-.5.29-.417.278-.97.423-1.529.27l-1.103-.303c-.109-.03-.175.016-.195.045-.22.312-.412.644-.573.99-.014.031-.021.11.059.19l.815.806c.411.406.562.957.53 1.456a4.709 4.709 0 0 0 0 .582c.032.499-.119 1.05-.53 1.456l-.815.806c-.081.08-.073.159-.059.19.162.346.353.677.573.989.02.03.085.076.195.046l1.102-.303c.56-.153 1.113-.008 1.53.27.161.107.328.204.501.29.447.222.85.629.997 1.189l.289 1.105c.029.109.101.143.137.146a6.6 6.6 0 0 0 1.142 0c.036-.003.108-.036.137-.146l.289-1.105c.147-.561.549-.967.998-1.189.173-.086.34-.183.5-.29.417-.278.97-.423 1.529-.27l1.103.303c.109.029.175-.016.195-.045.22-.313.411-.644.573-.99.014-.031.021-.11-.059-.19l-.815-.806c-.411-.406-.562-.957-.53-1.456a4.709 4.709 0 0 0 0-.582c-.032-.499.119-1.05.53-1.456l.815-.806c.081-.08.073-.159.059-.19a6.464 6.464 0 0 0-.573-.989c-.02-.03-.085-.076-.195-.046l-1.102.303c-.56.153-1.113.008-1.53-.27a4.44 4.44 0 0 0-.501-.29c-.447-.222-.85-.629-.997-1.189l-.289-1.105c-.029-.11-.101-.143-.137-.146a6.6 6.6 0 0 0-1.142 0ZM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0ZM9.5 8a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 9.5 8Z">
          </path>
        </svg>
      </div>
      <div *ngIf="!editReviewers && !isReviewerLoading">
        <div *ngFor="let reviewer of assignedReviewers" class="reviewer">
          {{reviewer.name}}
          <div class="reviewer-icon-container">
            <mat-icon *ngIf="!reviewer.approved && !reviewer.requested_for_change"
              style="color: #9a6700;">fiber_manual_record</mat-icon>
              <button [disabled]="isReRequestDisabled()" class="rerequest-review-btn" *ngIf="reviewer.approved || reviewer.requested_for_change" (click)="requestReReview(reviewer)" [featureActionState]="'CODE_REVIEW'"><mat-icon>autorenew</mat-icon></button>
            <mat-icon *ngIf="reviewer.approved" style="color: green;">check</mat-icon>
            <mat-icon *ngIf="reviewer.requested_for_change" style="color: red;">difference</mat-icon>
          </div>
        </div>
      </div>

      <form [formGroup]="codeReviewersForm" (ngSubmit)="updateAssignedReviewers()" *ngIf="editReviewers">

        <!-- MatSelect for Reviewer -->
        <mat-form-field appearance="fill">
          <!-- <mat-label>Reviewers</mat-label> -->
          <mat-select formControlName="reviewers" multiple>
            <mat-option *ngFor="let reviewer of reviewerOptions" [value]="reviewer">{{ reviewer.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <div class="btnnew">
          <button class="btn btn-primary newbtn" type="submit" [disabled]="!codeReviewersForm.valid" [featureActionState]="'CODE_REVIEW'">Submit</button>
          <button class="btn btn-primary newbtn" (click)="closeEditReviewers()">Cancel</button>
        </div>

      </form>
    </div>
  </div>
</div>

<ng-template #normalCommentTemplate let-comment="comment" let-i="pos">
  <div class="comment-container">

    <div *ngIf="comment.outdated" class="outdated">Outdated</div>

    <div class="comment-header">
      <span><strong>{{ comment.created_by }}</strong> commented on {{comment.created_time | date:'MMM d, yyyy, h:mm:ss
        a'}}</span>
      <mat-icon [matMenuTriggerFor]="normalCommentMenu" class="menu-icon" [featureActionState]="'CODE_REVIEW'">more_horiz</mat-icon>
    </div>
    <mat-menu #normalCommentMenu="matMenu">
      <button class="rightbtn" mat-menu-item (click)="onEdit(i)" [disabled]="commentsModification[i].isEditing">
        <mat-icon>edit</mat-icon>
        <span>Edit</span>
      </button>
      <button class="rightbtn" mat-menu-item (click)="onCommentDelete(i)">
        <mat-icon>delete</mat-icon>
        <span>Delete</span>
      </button>
    </mat-menu>

    <div class="comment-body" *ngIf="!commentsModification[i].isEditing">
      <p>{{ comment.body }}</p>
    </div>
    <div class="updatebtn" *ngIf="commentsModification[i].isEditing">
      <textarea [(ngModel)]="commentsModification[i].editText" placeholder="Type your comment here..."></textarea>
      <div class="textbtn">
        <button class="newbtn" (click)="onEditSubmit(i)"
          [disabled]="commentsModification[i].editText == '' || commentsModification[i].editText == comment.body" [featureActionState]="'CODE_REVIEW'">Update
          Comment</button>
        <button class="newbtn" (click)="onEditCancel(i)">Cancel</button>
      </div>

    </div>
  </div>
</ng-template>

<ng-template #reviewCommentTemplate let-comment="comment" let-i="pos">
  <div class="review-comment-container">
    <div class="review-header"><span><strong>{{ comment.created_by }}</strong> reviewed on {{comment.created_time |
        date:'MMM d, yyyy, h:mm:ss a'}}</span></div>
    <div class="comment-container">
      <div class="comment-header">
        <div>
          <strong>
            <span *ngIf="getFirstData(comment.technical_details_id) as firstData">
              {{ firstData.key | titlecase }}: {{ firstData.value }}
            </span>
          </strong>
          <span *ngIf="comment.outdated" class="outdated">Outdated</span>
        </div>
        <mat-icon [matMenuTriggerFor]="reviewCommentMenu" class="menu-icon" [featureActionState]="'CODE_REVIEW'">more_horiz</mat-icon>
      </div>
      <mat-menu #reviewCommentMenu="matMenu">
        <button mat-menu-item (click)="onEdit(i)" [disabled]="commentsModification[i].isEditing">
          <mat-icon>edit</mat-icon>
          <span>Edit</span>
        </button>
        <button mat-menu-item (click)="onCommentDelete(i)">
          <mat-icon>delete</mat-icon>
          <span>Delete</span>
        </button>
      </mat-menu>

      <div class="review-comment-header"><span><strong>{{ comment.created_by }}</strong> on {{comment.created_time |
          date:'MMM d, yyyy, h:mm:ss a'}}</span></div>
      <div class="comment-body" *ngIf="!commentsModification[i].isEditing">
        <p>{{ comment.body }}</p>
      </div>
      <div class="updatebtn" *ngIf="commentsModification[i].isEditing">
        <textarea [(ngModel)]="commentsModification[i].editText" placeholder="Type your comment here..."></textarea>
        <div class="comment_btn">
          <button class="newbtn" (click)="onEditSubmit(i)"
            [disabled]="commentsModification[i].editText == '' || commentsModification[i].editText == comment.body" [featureActionState]="'CODE_REVIEW'">Update
            Comment</button>
          <button class="newbtn" (click)="onEditCancel(i)">Cancel</button>
        </div>

      </div>

      <div *ngIf="comment.replies.length > 0" class="replies">
        <ng-container *ngFor="let replyId of comment.replies; let replyIndex = index">
          <ng-container *ngIf="getReply(replyId) as reply">
            <div class="reply-header">
              <div><span><strong>{{ reply.created_by }}</strong> on {{reply.created_time | date:'MMM d, yyyy, h:mm:ss
                  a'}}</span></div>
              <mat-icon [matMenuTriggerFor]="reviewCommentReplyMenu" class="menu-icon" [featureActionState]="'CODE_REVIEW'">more_horiz</mat-icon>
            </div>
            <mat-menu #reviewCommentReplyMenu="matMenu">
              <button mat-menu-item (click)="onReplyEdit(i, replyIndex)"
                [disabled]="commentsModification[i].replies[replyIndex].isEditing">
                <mat-icon>edit</mat-icon>
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="onCommentReplyDelete(i, replyIndex)">
                <mat-icon>delete</mat-icon>
                <span>Delete</span>
              </button>
            </mat-menu>
            <div class="comment-body" *ngIf="!commentsModification[i].replies[replyIndex].isEditing">
              <p>{{ reply.body }}</p>
            </div>
            <div class="updatebtn" *ngIf="commentsModification[i].replies[replyIndex].isEditing">
              <textarea [(ngModel)]="commentsModification[i].replies[replyIndex].editText"
                placeholder="Type your comment here..."></textarea>
              <div class="comment_btn">
                <button class="newbtn" (click)="onReplyEditSubmit(i, replyIndex)"
                  [disabled]="commentsModification[i].replies[replyIndex].editText == '' || commentsModification[i].replies[replyIndex].editText == reply.body" [featureActionState]="'CODE_REVIEW'">Update
                  Comment</button>
                <button class="newbtn" (click)="onReplyEditCancel(i, replyIndex)">Cancel</button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div *ngIf="!commentsModification[i].isReplying">
        <button class="mybtn newbtn" (click)="onReply(i)" [featureActionState]="'CODE_REVIEW'">Reply</button>
      </div>

      <div class="mybtn1" *ngIf="commentsModification[i].isReplying">
        <textarea [(ngModel)]="commentsModification[i].replyText" placeholder="Type your reply here..."></textarea>
        <div class="comment_btn">
          <button class="newbtn" (click)="onReplySubmit(i)"
            [disabled]="commentsModification[i].replyText == ''" [featureActionState]="'CODE_REVIEW'">Submit</button>
          <button class="newbtn" (click)="onReplyCancel(i)">Cancel</button>
        </div>
      </div>

      <div class="resolution-container">
        <button class="newbtn" *ngIf="comment.resolved" (click)="updateConversationResolution(i, false)" [featureActionState]="'CODE_REVIEW'">Unresolve
          Conversation</button>
        <button class="newbtn" *ngIf="!comment.resolved" (click)="updateConversationResolution(i, true)" [featureActionState]="'CODE_REVIEW'">Resolve
          Conversation</button>
        <span *ngIf="comment.resolved">{{comment.resolved_by}} marked this conversation as resolved</span>


      </div>
    </div>
  </div>
</ng-template>